import React, { useState, Fragment, useEffect } from 'react';
import PropTypes from 'prop-types';
import Button from '@mui/material/Button';
import { styled } from '@mui/material/styles';
import Dialog from '@mui/material/Dialog';
import DialogTitle from '@mui/material/DialogTitle';
import DialogContent from '@mui/material/DialogContent';
import DialogActions from '@mui/material/DialogActions';
import IconButton from '@mui/material/IconButton';
import Typography from '@mui/material/Typography';
import { Stack, Grid, Box } from '@mui/material';
import moment from "moment";
import useMediaQuery from '@mui/material/useMediaQuery';
import { useTheme } from '@mui/material/styles';
import useStore from '../../../../../modules/utils/store';
import closeImg from '../../../../../resources/images/campaign/modal_close.svg'
import Input, { Checkbox, Hint, Radio, TextArea } from "../../../TypeA/component/UI/Input"
import { MuiSelects } from "../../../TypeA/component/UI/CampaignSelect";
import { _API, _CK, _U } from "../../../../../modules/utils";
import { calculatePreRegisterProgress } from "../../../utils/preRegisterProgress";

const matchesCampaignInputTarget = (item, eventList = []) => {
  const onOffUse = item?.onOffUse;
  const hasOfflineSelection = eventList?.some((event) => event?.offlineChecked);
  const hasOnlineSelection = eventList?.some((event) => event?.onlineChecked);

  if (!hasOfflineSelection && !hasOnlineSelection) {
    return onOffUse === "ONOFF";
  }

  return (
    (hasOfflineSelection && ["OFF", "ONOFF"].includes(onOffUse)) ||
    (hasOnlineSelection && ["ON", "ONOFF"].includes(onOffUse))
  );
};

const BootstrapDialog = styled(Dialog)(({ theme }) => ({
  '.MuiPaper-root': {
    width: "100%",
    maxWidth: "900px",
    borderRadius: "8px",
    backgroundColor: "#fff",
    display: "flex",
    flexDirection: "column",
    maxHeight: "90vh",
    overflow: "hidden",
  },
  '.MuiDialogTitle-root': {
    padding: "0px",
    textAlign: "right"
  },
  '& .MuiDialogContent-root': {
    padding: theme.spacing(2.5),
    borderTop: "0px",
    borderBottom: "1px solid #eee",
  },
  '& .MuiDialogContent-root h3': {
    fontSize: "22px",
    fontWeight: "bold"
  },
  '& .MuiDialogContent-root h4': {
    fontWeight: "bold"
  },
  '& .MuiDialogContent-root b': {
    fontSize: "30px",
    fontWeight: "bold",
    wordBreak: "keep-all"
  },
  '& .MuiDialogContent-root .MuiBox-root': {
    background: "#f7f7fa",
    borderRadius: "6px",
    padding: "20px"
  },

  '& .MuiDialogActions-root': {
    padding: theme.spacing(2.5),
  },
  '.MuiButton-root': {
    backgroundColor: "#6a6af8",
    color: "#fff",
    borderRadius: "4px",
    lineHeight: "40px",
    minWidth: "100px",
    height: "40px",
    fontSize: "15px"
  },
  '.MuiButton-root:hover': {
    backgroundColor: "#6a6af8",
  },
  '.subtitleText': {
    width: "160px",
    wordWrap: "break-word",
    wordBreak: "keep-all"
  },
  '.subtitleDesc:before': {
    content: "''",
    display: "inline-block",
    width: "1px",
    height: "12px",
    background: "#efefef",
    margin: "0 16px",
  },
  '.cancel_btn': {
    display: "inline-flex",
    alignItems: "center",
    justifyContent: "center",
    padding: "8px 16px",
    borderRadius: "4px",
    backgroundColor: "#EBEBF8"
  },
  '.modal_btn': {
    display: "inline-flex",
    alignItems: "center",
    justifyContent: "center",
    padding: "8px 16px",
    borderRadius: "4px",
    backgroundColor: "#5959EF"
  },
  '.cont_left_inner4 > div > h6': {
    padding: "8px 0",
    borderBottom: "1px solid #D9D9D9",
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
  },
  '.cont_left_inner4 .section_box:first-child':{paddingTop:"24px"},
  '@media (max-width:767px)': {
    '.MuiPaper-root': {
      borderRadius: "0px",
    },
    '.subtitleDesc:before': {
      content: 'none',
    },
  },
}));

const BootstrapDialogTitle = (props) => {
  const { children, onClose, ...other } = props;

  return (
    <DialogTitle sx={{ m: 0, p: 2 }} {...other}>
      {children}
      {onClose ? (
        <IconButton
          aria-label="close"
          onClick={onClose}
          sx={{
            padding: "0px"
          }}
        >
          <img src={closeImg} />
        </IconButton>
      ) : null}
    </DialogTitle>
  );
};

BootstrapDialogTitle.propTypes = {
  children: PropTypes.node,
  onClose: PropTypes.func.isRequired,
};

export default function PreRegisterDialog(props) {
  const { open, setOpen, myPreRegInfoList, saveList, preregCompName, selectConnectPath, eventList, campaignIdx, mgrName, siteEventLabel, eventLabel, sessionLabel, progressStandard, campaignInfo } = props;
  const { savePreregName, setSavePreregName, savePreregMobile, setSavePreregMobile, savePreregEmail, setSavePreregEmail } = useStore();
  const [step, setStep] = useState(1);
  const theme = useTheme();
  const fullScreen = useMediaQuery(theme.breakpoints.down('sm'));
  const [choiceHospitalInputIdx, setChoiceHospitalInputIdx] = useState(null);
  const [saveStatus, setSaveStatus] = useState(false);
  const isBilingual = Number(campaignIdx) === 100;
  const mmt = (date) => isBilingual ? moment(date).locale('en') : moment(date);

  const handleClickOpen = () => {
    setOpen(true);
  };

  /**
* 섹션, 입력항목 Component
* @param {*} props {item, onDataChange}
* @returns 
*/

  const ChildInput = (props) => {
    const { item,className } = props;

    const [editInput, setEditInput] = useState({});
    console.log(item);
    return (
      <Stack direction="column" sx={{ gap: `${item.name=="기본정보"?"8px":"24px"}` }}>
        {item?.children?.filter((child) =>
          child?.inputType == 'SECTION'
          || (
            child?.useYn == 'Y'
            ||
            child?.isAlwaysShow
            && child?.onlyHost != 'Y'
            && (
              child?.defaultYn == 'Y'
              || matchesCampaignInputTarget(child, eventList)
            )
          )
        )?.map((child, i) => {
          return (
              child?.inputType == 'SECTION' ? (
                <Stack className="section_box" key={`${child?.idx}_${i}`} sx={{ gap: "24px", margin: i == item?.children?.length - 1 ? '0px' : '24px 0' }}>
                  <Stack sx={{ gap: "8px" }}>
                    <Typography component="h5" variant="h7" sx={{ display: 'flex', justifyContent: "space-between" }}>
                      {child?.name}
                    </Typography>
                    {child?.description && (
                      <Typography component="p" variant="p" sx={{ paddingBottom: "8px", marginBottom: "24px" }}>{child?.description}</Typography>
                    )}
                  </Stack>
                  {item?.children.length > 0 && (
                    <ChildInput item={child} />
                  )}
                </Stack>
            ) : (
              <div style={{ display: "flex", flexDirection: `${fullScreen ? "column" : "row"}`, width: `100%` }}>
                {(child?.fieldName == 'MANAGER' && ['MANAGER_SELECT','MANAGER_TEXT'].includes(child?.inputType)) ? (
                    <>
                    <Typography component="h4" variant="h4" className="subtitleText" sx={{ padding: `${fullScreen ? "0px" : "7px 0"}`, marginBottom: `${fullScreen ? "8px" : "0"}` }}>{child?.name}</Typography>
                    <Typography component="p" variant="h8" className="subtitleDesc" sx={{ padding: "5px 0" }}>{mgrName ? mgrName : child?.value}</Typography>
                  </>
                  ) :
                ['TEXT', 'EMAIL', 'MOBILE'].includes(child?.inputType) ? (
                  <>
                    <Typography component="h4" variant="h4" className="subtitleText" sx={{ padding: `${fullScreen ? "0px" : "7px 0"}`, marginBottom: `${fullScreen ? "8px" : "0"}` }}>{child?.name}</Typography>
                    <Typography component="p" variant="h8" className="subtitleDesc" sx={{ padding: "5px 0" }}>{child?.value}</Typography>
                  </>
                ) : child?.inputType == 'TEXTAREA' ? (
                  <>
                    <Typography component="h4" variant="h4" className="subtitleText" sx={{ padding: `${fullScreen ? "0px" : "7px 0"}`, marginBottom: `${fullScreen ? "8px" : "0"}` }}>{child?.name}</Typography>
                    <Typography component="p" variant="h8" className="subtitleDesc" sx={{ padding: "5px 0",display:"flex", alignItems:"center" }}>
                      <pre style={{color:" #646464",fontSize: "15px",fontWeight: "400", lineHeight: "22px"}}  dangerouslySetInnerHTML={{ __html: child?.value }} />
                    </Typography>
                  </>
                ) : child?.inputType == 'CHECKBOX' ? (
                  <>
                    <Typography component="h4" variant="h4" className="subtitleText" sx={{ padding: `${fullScreen ? "0px" : "7px 0"}`, marginBottom: `${fullScreen ? "8px" : "0"}` }}>{child?.name}</Typography>
                    <Typography component="p" variant="h8" className="subtitleDesc" sx={{ padding: "5px 0" }}>
                    {/*   {child?.opts?.filter((opt) => opt.checked == true && opt?.isAllCheck == false)?.map((opt, index, array) => {
                        if (array.length === 1 || index === array.length - 1) {
                          return opt.label;
                        } else {
                          return opt.label + ', ';
                        }
                      })} */}
                              {child?.opts?.filter((opt) => opt.checked == true)?.map((opt, index, array) => {
                                if (!opt?.isAllCheck) {
                                  if (array.length === 1 || index === array.length - 1) {
                                    return opt.label;
                                  } else {
                                    return opt.label + ', ';
                                  }
                                } else {
                                  opt.label;
                                }
                              })}
                    </Typography>
                  </>
                ) : child?.inputType == 'RADIO' ? (
                  <>
                    <Typography component="h4" variant="h4" className="subtitleText" sx={{ padding: `${fullScreen ? "0px" : "7px 0"}`, marginBottom: `${fullScreen ? "8px" : "0"}` }}>{child?.name}</Typography>
                    <Typography component="p" variant="h8" className="subtitleDesc" sx={{ padding: "5px 0" }}>
                      {child?.opts?.filter((opt) => opt.checked == true)?.map((opt) => opt.label)}
                    </Typography>
                  </>
                ) : child?.inputType == 'SELECT' ? (
                  <>
                    <Typography component="h4" variant="h4" className="subtitleText" sx={{ padding: `${fullScreen ? "0px" : "7px 0"}`, marginBottom: `${fullScreen ? "8px" : "0"}` }}>{child?.name}</Typography>
                    <Typography component="p" variant="h8" className="subtitleDesc" sx={{ padding: "5px 0" }}>
                      {child?.opts?.filter((opt) => opt.value == child?.value)?.map((opt) => opt.label)}
                    </Typography>
                  </>
                ) : child?.inputType == 'HOSPITAL' ? (
                  <>
                    <Typography component="h4" variant="h4" className="subtitleText" sx={{ padding: `${fullScreen ? "0px" : "7px 0"}`, marginBottom: `${fullScreen ? "8px" : "0"}` }}>{child?.name}</Typography>
                    <Typography component="p" variant="h8" className="subtitleDesc" sx={{ padding: "5px 0" }}>{child?.value}</Typography>
                  </>
                ) : (child?.inputType == 'TERMS' && (matchesCampaignInputTarget(child, eventList) || child?.isAlwaysShow)) ? (
                  // <Stack direction="row" alignItems="flex-start" sx={{ gap: "16px", paddingTop: "8px" }}>
                    <>
                  <Typography component="h4" variant="h4" className="subtitleText" sx={{ padding: `${fullScreen ? "0px" : "7px 0"}`, marginBottom: `${fullScreen ? "8px" : "0"}` }}>{child?.name}</Typography>
                  <Typography component="p" variant="h8" className="subtitleDesc" sx={{ padding: "5px 0" }}>{child?.checked == true ? (isBilingual ? 'Agree (동의함)' : '동의함') : (isBilingual ? 'Disagree (동의안함)' : '동의안함')}</Typography>
                  {/*   <Box>
                      <Box>
                        <Box sx={{ padding: "12px", background: "#F7F7FA", borderRadius: "4px", margin: "8px 0 8px auto", height: "130px", overflowY: "auto" }}>
                          <div dangerouslySetInnerHTML={{ __html: child?.termsContents }} /> 
                        </Box>
                        <Typography component="p" variant="p" sx={{ marginBottom: "4px" }}>{child?.termsQuestion}</Typography> 
                        <Checkbox
                          items={[{ label: '동의함', value: true, checked: child?.value }]}
                          onChange={(e) => {
                            handleChange(child?.idx, e?.target?.checked);
                          }}
                          height="40px"
                        /> 
                      </Box>
                    </Box> */}
                    </>
                  // </Stack>
                ) 
                  : (
                  <></>
                )}
              </div>
            )
          )
        })}
      </Stack>

    )
  }

  const saveBefore = (e) => {

    if (e) e.preventDefault();

    setSaveStatus(true);
    
  };

  const onSave = async (e) => {

    const req = {
      path: "/v1/campaign/reg/single/save",
      data: {
        campaignIdx: campaignIdx,
        inputs: [...myPreRegInfoList],
        eventList: eventList.filter((e) => e.onlineChecked == true || e.offlineChecked).map((item) => progressStandard == 'SESSION' ? { ...item, sessionIdx: item?.sessionIdx || item?.idx } : item),
        regStatus : 'C',
        noAuthorCheck: true,
        campaignInfo: campaignInfo,
        progressStandard: progressStandard

      },
    };

    await _API.post(req).then((res) => {

      const { data } = res;

      if (data) {
        setStep(2);
      }

    });

  };

  /**
 * 입력항목 입력
 * @param {*} newData 
 */
  const onDataChange = (newData) => {
    // 변경된 데이터로 상태 업데이트
    const { item } = findItemByIndex(myPreRegInfoList, newData?.idx);
    Object.assign(item, newData);
  }

  const findItemByIndex = (array, targetIdx, parent = null) => {
    for (let i = 0; i < array.length; i++) {
      if (array[i].idx == targetIdx) {
        return { item: array[i], parent: parent };
      }
      else if (array[i]?.children) {
        const result = findItemByIndex(array[i].children, targetIdx, array[i]);
        if (result) {
          return result;
        }
      }
    }
    return null;
  }

  const handleClose = () => {
    setOpen(false);
    setSavePreregName(null)
    setSavePreregMobile(null)
    setSavePreregEmail(null)
    // window.location.reload();
  };

  useEffect(() => {
    if (saveStatus) onSave();
  }, [saveStatus]);
  return (
    <BootstrapDialog
      aria-labelledby="customized-dialog-title"
      open={open}
      fullScreen={fullScreen}
    >
      <div style={{display:"flex",alignItems:"center", justifyContent:"space-between", padding: `${fullScreen ? "20px 20px 8px" : "20px 30px 8px"}`}}>
        <Typography component="h2" variant="event_h2">{ step==1? (isBilingual ? 'Confirm Registration Details (신청내용 확인)' : '신청내용 확인') : (isBilingual ? 'Registration Complete (등록신청 완료)' : '등록신청 완료')}</Typography>
        <button><img src={closeImg} onClick={handleClose} style={{display:"block"}} /></button>
      </div>
      {/* Plan Design Review §6.8 - mobile (<sm) sticky progress indicator
          §6.8-2 - step==1 에서 필수/약관/세션 진행률 (count text + 4px native progress) 추가.
          step==2 는 기존 완료 안내만 유지. CTA disable 은 하지 않고 기존 saveBefore validation 을 유지. */}
      {fullScreen && (() => {
        const progress = calculatePreRegisterProgress({
          myPreRegInfoList,
          eventList,
          progressStandard,
        });
        return (
          <div
            data-prereg-mobile-progress
            className="sticky top-0 z-10 bg-white border-b border-border-light"
          >
            <div className="flex items-center gap-2 px-5 pt-2 pb-1.5 text-xs text-text-secondary min-h-[28px]">
              <span data-prereg-mobile-progress-step>
                {isBilingual ? `Step ${step}/2` : `${step}/2 단계`} - {step == 1 ? (isBilingual ? 'Confirm (신청내용 확인)' : '신청내용 확인') : (isBilingual ? 'Complete (완료 안내)' : '완료 안내')}
              </span>
              {step == 1 && (
                <span data-prereg-mobile-progress-counts className="ml-auto text-[11px]">
                  {isBilingual ? 'Required' : '필수'} {progress.requiredFields.filled}/{progress.requiredFields.total}
                  {progress.terms.total > 0 && ` · ${isBilingual ? 'Terms' : '약관'} ${progress.terms.agreed}/${progress.terms.total}`}
                  {progress.session.required > 0 && ` · ${isBilingual ? 'Session' : '세션'} ${progress.session.selected}/${progress.session.required}`}
                </span>
              )}
            </div>
            {step == 1 && (
              <progress
                data-prereg-mobile-progress-bar
                aria-label={isBilingual ? 'Registration progress (신청 진행률)' : '신청 진행률'}
                value={progress.percentComplete}
                max={100}
                className="h-1 w-full overflow-hidden rounded-full accent-indigo-500 bg-zinc-100"
              />
            )}
          </div>
        );
      })()}
      {step == 1 ? (
        <div style={{ display: "flex", flexDirection: "column", gap: "60px", flex: "1 1 auto", minHeight: 0, overflowY: "auto",padding: `${fullScreen ? "0px 20px 0" : "00px 30px 0"}` }}>
          <div style={{ display: "flex", alignItems: "center", flexDirection: "column", gap: "12px", marginTop:"50px" }}>
            <Typography component="h2" variant="title" sx={{textAlign: "center", fontSize:`${fullScreen ? "20px" : "26px"}`,lineHeight:`${fullScreen ? "26px" : "35.41px"}`,fontWeight:`${fullScreen ? "700" : "900"}`,wordBreak: "keep-all", wordWrap: "break-word"}}>{isBilingual ? <>Please review your registration details.<br />(신청내용을 확인해 주시기 바랍니다.)</> : '신청내용을 확인해 주시기 바랍니다.'}</Typography>
            <Typography component="p" variant="desc" sx={{textAlign:"center",wordBreak: "keep-all", wordWrap: "break-word"}}>{isBilingual ? 'We have confirmed your registration details as follows. Please review the information and complete your registration. (신청하신 내용을 다음과 같이 확인하였습니다. 신청내용을 확인 후 참가신청을 완료해 주시기 바랍니다.)' : '신청하신 내용을 다음과 같이 확인하였습니다. 신청내용을 확인 후 참가신청을 완료해 주시기 바랍니다.'}</Typography>
          </div>
          <div style={{ display: "flex", flexDirection: "column", gap: "40px" }}>
            <div style = {{ display: "flex", flexDirection: "column", gap: "24px" }}>
              {eventList.filter((e) => e.onlineChecked == true || e.offlineChecked).length > 0 && (
                <Typography component="h3" variant="h3" sx={{ padding: "8px 0", borderBottom: "1px solid #d9d9d9" }}>{progressStandard == 'EVENT' ? eventLabel : sessionLabel}</Typography>
              )}
              {eventList.filter((e) => e.onlineChecked == true || e.offlineChecked)?.map((item, i) => {
                const selectedName = progressStandard == 'SESSION' ? (item?.sessionName || item?.name || item?.eventName) : item?.eventName;
                return (
                  <div style={{ display: "flex", flexDirection: "column", alignItems: "flex-start", justifyContent: "space-between", gap: "9px",paddingBottom:"24px", borderBottom:"1px solid #efefef" }}>
                      <div style={{ display: "flex", flexDirection: "column", gap: "4px", width: "100%" }}>
                        <Typography component="h5" variant="h5">{selectedName}</Typography>
                        <Typography component="span" variant="span">
                          {item?.startDate && mmt(item.startDate).format("YYYY.MM.DD(ddd) HH:mm")}{" "}
                          {item?.endDate && ` ~ `}
                          {item?.endDate &&
                            (mmt(item?.startDate).format("YYYY.MM.DD(ddd)") ===
                              mmt(item?.endDate).format("YYYY.MM.DD(ddd)")
                              ? mmt(item?.endDate).format("HH:mm")
                              : mmt(item?.endDate).format("YYYY.MM.DD(ddd) HH:mm"))}
                          {(item?.startDate && item?.endDate) && ' KST'}
                        </Typography>
                      </div>
                      <div style={{ display: "flex", flexDirection: "column", gap: "4px" }}>
                        <Typography component="span" variant="span">
                          {(item.onlineChecked && item.offlineChecked) ? (isBilingual ? 'Online & Offline Attend (온오프라인 참가)' : '온오프라인 참가') :
                            item.onlineChecked ? (isBilingual ? 'Online Attend (온라인 참가)' : '온라인 참가') :
                              item.offlineChecked ? (isBilingual ? 'Offline Attend (오프라인 참가)' : '오프라인 참가') : ''
                          }
                        </Typography>
                      </div>
                  </div>
                );
              })}
            </div>
            {myPreRegInfoList?.filter((item) =>
              item?.children?.filter((c) => c?.onlyHost != 'Y')?.length > 0
              && item?.onlyHost != 'Y'
              ||
              (item?.isTermsGroup == 'Y' && item?.children?.length > 0)
              && (
                item?.defaultYn == 'Y'
                || matchesCampaignInputTarget(item, eventList)
              )
            )?.map((item, index) => {
              const isTermsGroup = item?.isTermsGroup === 'Y';
              return (
                <div
                  className={`cont_left_inner cont_left_inner4 flex flex-col gap-6 ${fullScreen && isTermsGroup ? "border-t border-border-light pt-6 mt-2" : ""}`}
                  data-prereg-terms-group={isTermsGroup ? "true" : undefined}
                >
                  <Stack sx={{ gap: "12px" }}>
                    <Typography component="h6" variant="h6" sx={{padding:"8px 0"}}>{item?.name}</Typography>
                    {item?.description && (
                      <Typography component="p" variant="p" sx={{ marginBottom: "12px" }}>{item?.description}</Typography>
                    )}
                  </Stack>
                  <ChildInput item={item} />
                </div>
              )
            })}

          </div>
        </div>
      ) : step == 2 && (
        <div style={{ display: "flex", flexDirection: "column", gap: "60px", flex: "1 1 auto", minHeight: 0, overflowY: "auto",padding:`${fullScreen ? "0px 20px 20px" : "0px 30px 20px"}` }}>
          <div style={{ display: "flex", alignItems: "center", flexDirection: "column", gap: "12px",marginTop:"50px" }}>
            <div style={{ display: "flex", flexDirection: "column", alignItems: "center", gap: "4px" }}>
                <Typography component="h2" variant="title" sx={{ textAlign: "center",fontSize:`${fullScreen ? "20px" : "26px"}`,lineHeight:`${fullScreen ? "26px" : "35.41px"}`,fontWeight:`${fullScreen ? "700" : "900"}`,wordBreak: "keep-all", wordWrap: "break-word"}}>{isBilingual ? 'Your registration has been completed. (참가신청이 완료되었습니다.)' : '참가신청이 완료되었습니다.'}</Typography>
              {/* <Typography component="h3" variant="subtext9">#21544874</Typography> */}
            </div>
            <Typography component="p" variant="desc" sx={{ textAlign: "center",wordBreak: "keep-all", wordWrap: "break-word" }}>
              {isBilingual ? (
                <>
                  Your registration has been successfully processed.<br />
                  (참가신청이 정상적으로 처리되었습니다.)<br /><br />
                  Detailed information about the schedule and participation methods will be sent to your registered email or mobile number.<br />
                  (향후 일정 및 참가 방법에 대한 상세 안내는 등록하신 이메일이나 문자로 발송될 예정입니다.)<br /><br />
                  If you have any additional questions, please contact the person in charge.<br />
                  (추가 문의사항이 있으시면 담당자에게 연락 주시기 바랍니다.)<br />
                </>
              ) : (
                <>
                  참가신청이 정상적으로 처리되었습니다.<br /><br />
                  향후 일정 및 참가 방법에 대한 상세 안내는 등록하신 이메일이나 문자로 발송될 예정입니다.<br />
                  추가 문의사항이 있으시면 담당자에게 연락 주시기 바랍니다.<br />
                </>
              )}
            </Typography>
          </div>
        </div>
      )}
      {/* Plan Design Review §6.8 - mobile sticky bottom CTA + full-width buttons / desktop unchanged */}
      <div
        data-prereg-mobile-cta-wrap={fullScreen ? "true" : undefined}
        style={fullScreen ? undefined : {
          display: "flex",
          flexDirection: "row",
          alignItems: "center",
          justifyContent: step == 1 ? "space-between" : "flex-end",
          width: "100%",
          padding: "30px 20px",
        }}
        className={fullScreen
          ? "sticky bottom-0 left-0 right-0 z-10 bg-white border-t border-border-light flex flex-col-reverse gap-2 items-stretch px-5 pb-4 pt-3"
          : ""
        }
      >
        {step == 1 ? (
          <>
            <Button
              type="button"
              className={`cancel_btn ${fullScreen ? "!w-full !h-12" : ""}`}
              onClick={handleClose}
            >
              <Typography component="span" variant="button" sx={{ color: "#464f60" }}>{isBilingual ? 'Cancel (취소)' : '취소'}</Typography>
            </Button>
            <Button
              type="button"
              className={`modal_btn ${fullScreen ? "!w-full !h-12" : ""}`}
              onClick={(e) => saveBefore(e)}
            >
              <Typography component="span" variant="button" sx={{ color: "#fff" }}>{isBilingual ? 'Submit (참가신청 완료)' : '참가신청 완료'}</Typography>
            </Button>
          </>
        ): step == 2 && (
          <Button
            type="button"
            className={`modal_btn ${fullScreen ? "!w-full !h-12" : ""}`}
            onClick={() => window.location.reload()}
          >
            <Typography component="span" variant="button" sx={{ color: "#fff" }}>{isBilingual ? 'Complete (확인)' : '확인'}</Typography>
          </Button>
        )}
      </div>
    </BootstrapDialog>
  );
}
